const modpacks = [
  {
    id: 'atm10',
    name: 'All The Mods 10',
    version: '8.1',
    short: 'A comprehensive modpack with a bit of everything for Minecraft 1.21.1',
    description: 'All The Mods 10 is a popular modpack that brings together a wide variety of mods to enhance your Minecraft experience. From technology and magic to exploration and building, this modpack has something for every type of player. Dive into a world filled with new challenges, adventures, and endless possibilities!',
    images: [
      '/images/atm10/atm10-1.jpg',
      '/images/atm10/atm10-2.jpg',
    ],
    ip: 'atm10.madhouseminers.com',
  },
  {
    id: 'atm10tts',
    name: 'All The Mods 10 - To The Sky',
    version: '2.0.4',
    short: 'That good old All The Mods 10 experience, but with a skyblock twist!',
    description: 'All The Mods 10 - To The Sky takes the beloved All The Mods 10 modpack and transforms it into an exciting skyblock adventure. Starting on a small floating island, players must utilize the extensive mod selection to gather resources, build structures, and progress through various challenges. This unique twist on the classic modpack offers a fresh and engaging experience for both new and veteran players alike.',
    images: [
      '/images/atm10tts/tts-1.jpg',
    ],
    ip: 'tts.madhouseminers.com',
  },
  {
    id: 'atm11',
    name: 'All The Mods 11',
    version: ' 0.8.0-beta',
    short: 'The latest iteration of the All The Mods series, bringing new features and mods to Minecraft 26.1.2',
    description: 'All The Mods 11 is the newest addition to the All The Mods series, offering players an updated and enhanced Minecraft experience. With a focus on innovation and creativity, this modpack introduces a variety of new mods, features, and gameplay mechanics that push the boundaries of what players can achieve in the game.',
    images: [
      '/images/atm11/atm11.png',
    ],
    ip: 'atm11.madhouseminers.com',
  }
]

export default modpacks;
